import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { ARROW_DOWN } from '../../../constants/iconNames';
import { INCOMPLETE_WITHOUT_CODE } from '../../../constants/status-codes';
import { DOT_DAY_MONTH_YEAR } from '../../../constants/dateFormats';
import Icon from '../../../icons';
import Variables from '../../../styles/variables.scss';
import '../containers/addressHistory.scss';
export default function DropdownButton({ closeDropdown, open, singleAddressHistory: { registeredDate, status, workOrderId, serviceTypeName }, toggleDropdown, }) {
    return (_jsx("button", { onClick: () => toggleDropdown(open === workOrderId ? 1 : workOrderId), className: status.includes(INCOMPLETE_WITHOUT_CODE)
            ? 'address_history__dropdown--red'
            : 'address_history__dropdown--blue', children: _jsxs("div", { children: [_jsxs("span", { children: [serviceTypeName, " "] }), _jsxs("div", { className: "address_history__dropdown--right", children: [_jsx("span", { children: moment(registeredDate.slice(0, 10)).format(DOT_DAY_MONTH_YEAR) }), _jsx("span", { className: closeDropdown ? 'rotate-down' : 'rotate-up', children: _jsx(Icon, { stroke: Variables.blackPrimary, name: ARROW_DOWN }) })] })] }) }));
}
DropdownButton.propTypes = {
    singleAddressHistory: PropTypes.objectOf(PropTypes.any).isRequired,
    closeDropdown: PropTypes.bool.isRequired,
    open: PropTypes.number.isRequired,
    toggleDropdown: PropTypes.func.isRequired,
};
